import moment from 'moment'

import COLORS from 'pared/constants/colors'

import { IConfigsType } from '../../types'

const bibibopDeliveryConfig: IConfigsType = {
  bibibop: {
    '/:brand/corporate_delivery': {
      variables: [
        'corporateGroup',
        {
          type: 'date',
          types: [
            'week',
            'period',
            'quarter',
            'year',
            'trailing_7_days',
            'custom_date_range',
          ],
          endDate: moment().startOf('weeks').format('YYYY-MM-DD'),
        },
      ],
      groupFilter: {
        api: 'bbbCorporateFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'trailing_7_days',
          'custom',
        ],
        endDate: moment().startOf('weeks').format('YYYY-MM-DD'),
      },
      title: {
        type: 'title',
        title: 'Systemwide Delivery',
        subTitle: ['Updated Weekly'],
      },
      listLocationGroupDeliveryKpis: {
        type: 'list',
        api: 'bibibopListLocationGroupDeliveryKpis',
        fieldWidth: '160px',
        fields: [
          {
            content: {
              key: 'totalOrderCount',
            },
            bottom: '# of Delivery Orders	',
          },
          {
            content: {
              key: 'sumSubtotal',
            },
            bottom: 'Delivery Sales',
          },
          {
            content: {
              key: 'completedDisputeAmount',
            },
            bottom: 'Completed Disputes',
          },
          {
            content: {
              key: 'deliveryAvgDasherWaitTimeDoordash',
              decimal: 1,
              format: '<%- valueStr + " min" %>',
            },
            bottom: 'Average Driver Wait Time',
          },
          {
            content: {
              key: 'deliveryOrderWithAnyIssuePercentDoordash',
              decimal: 1,
            },
            bottom: '% Orders w/ Any Issues',
          },
          {
            content: {
              key: 'deliveryAvgCustomerReviewScoreDoordash',
              decimal: 2,
            },
            bottom: 'Doordash Rating',
          },
        ],
      },
      breakdownOfIssuesTitle: {
        type: 'title',
        title: 'Breakdown of Order Issues',
      },
      breakdownOfIssuesKpis: {
        type: 'list',
        api: 'listLocationGroupDeliveryKpis',
        fieldWidth: '160px',
        fields: [
          {
            content: {
              key: 'deliveryInaccurateOrderPercentDoordash',
              decimal: 1,
            },
            bottom: 'Accuracy',
          },
          {
            content: {
              key: 'deliveryCancelledOrderPercentDoordash',
              decimal: 1,
            },
            bottom: 'Cancellations',
          },
          {
            content: {
              key: 'deliveryDelayedOrderPercentDoordash',
              decimal: 1,
            },
            bottom: 'Lateness',
          },
        ],
      },
      deliveryTrendFilters: {
        type: 'title',
        title: 'Delivery Chart',
      },
      deliveryTrendChart: {
        type: 'line-chart',
        api: 'bbbTrendLocationGroupDelivery',
        width: 1100,
        height: 500,
        label: 'date',
        datasets: [
          {
            key: 'deliveryOrderWithAnyIssuePercentDoordash',
            label: 'Orders w/ Any Issues',
            borderColor: COLORS.Basil,
            backgroundColor: COLORS.Basil,
            chartType: 'line',
            decimal: 1,
          },
          {
            key: 'deliveryInaccurateOrderPercentDoordash',
            label: 'Accuracy',
            borderColor: COLORS.Pomodoro,
            backgroundColor: COLORS.Pomodoro,
            chartType: 'line',
            decimal: 1,
          },
          {
            key: 'deliveryCancelledOrderPercentDoordash',
            label: 'Cancellations',
            borderColor: COLORS.Expo,
            backgroundColor: COLORS.Expo,
            chartType: 'line',
            decimal: 1,
          },
          {
            key: 'deliveryDelayedOrderPercentDoordash',
            label: 'Lateness',
            borderColor: COLORS.Mango,
            backgroundColor: COLORS.Mango,
            chartType: 'line',
            decimal: 1,
          },
          {
            key: 'totalOrderCount',
            label: '# of Delivery Orders',
            borderColor: COLORS.Smoke,
            backgroundColor: COLORS.Smoke,
            chartType: 'bar',
            yAxisID: 'y1',
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
            decimal: 0,
          },
          y1: {
            type: 'number',
          },
        },
        options: {
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {},
            y1: {
              title: {
                text: '# of Delivery Orders',
                display: true,
              },
              position: 'right',
              grid: {
                drawOnChartArea: false,
              },
            },
          },
        },
      },
      deliveryMetrics: {
        type: 'table-v2',
        title: 'Delivery Metrics',
        api: 'bbbListLocationGroupDeliveryData',
        pagination: { pageSize: 20 },
        sorting: [
          {
            id: 'totalOrderCount',
            desc: true,
          },
        ],
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
          },
          {
            key: 'totalOrderCount',
            title: '# of Delivery Orders',
            align: 'center',
            sortable: true,
          },
          {
            key: 'sumSubtotal',
            title: 'Delivery Sales ($)',
            align: 'center',
            sortable: true,
          },
          {
            key: 'deliveryAvgDasherWaitTimeDoordash',
            title: 'Avg Driver Wait Time',
            align: 'center',
            decimal: 1,
            sortable: true,
            format: '<%- valueStr + " min" %>',
          },
          {
            key: 'deliveryAvgCustomerReviewScoreDoordash',
            title: 'Delivery Rating',
            align: 'center',
            decimal: 2,
            sortable: true,
          },
        ],
      },
      disputeMetrics: {
        type: 'table-v2',
        title: 'Dispute Metrics',
        api: 'bbbDisputeMetrics',
        pagination: { pageSize: 20 },
        sorting: [
          {
            id: '<%- corporateGroup?.tableColumns[0].key %>',
            desc: true,
          },
        ],
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
          },
          {
            key: 'deliveryOrderWithAnyIssuePercentDoordash',
            title: '% Orders with Issues',
            align: 'center',
            width: '150px',
            sortable: true,
          },
          {
            key: 'totalDisputeCount',
            title: 'Total Disputes #',
            align: 'center',
            width: '75px',
            sortable: true,
          },
          {
            key: 'totalDisputeAmount',
            title: 'Total Disputes $',
            align: 'center',
            width: '75px',
            decimal: 2,
            sortable: true,
          },
          {
            key: 'completedDisputeCount',
            title: 'Completed Disputes #',
            align: 'center',
            width: '75px',
            sortable: true,
          },
          {
            key: 'completedDisputeAmount',
            title: 'Completed Disputes $',
            align: 'center',
            width: '75px',
            decimal: 2,
            sortable: true,
          },
          {
            key: 'pendingDisputeCount',
            title: 'Pending Disputes #',
            align: 'center',
            width: '75px',
            sortable: true,
          },
          {
            key: 'pendingDisputeAmount',
            title: 'Pending Disputes $',
            align: 'center',
            width: '75px',
            decimal: 2,
            sortable: true,
          },
          {
            key: 'lostDisputeCount',
            title: 'Lost Disputes #',
            align: 'center',
            width: '75px',
            sortable: true,
          },
          {
            key: 'lostDisputeAmount',
            title: 'Lost Disputes $',
            align: 'center',
            width: '75px',
            decimal: 2,
            sortable: true,
          },
        ],
      },
      disputeReasonMetrics: {
        type: 'table-v2',
        title: 'Dispute Reason Metrics',
        api: 'bbbDisputeReason',
        pagination: { pageSize: 20 },
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'reason',
            title: 'Reason',
            align: 'center',
            sortable: true,
          },
          {
            key: 'totalCount',
            title: '# of Orders',
            width: '75px',
            align: 'center',
            sortable: true,
          },
          {
            key: 'totalOrderPercent',
            title: '% of Orders',
            width: '75px',
            align: 'center',
            sortable: true,
          },
          {
            key: 'totalAmount',
            title: '$',
            width: '75px',
            align: 'center',
            sortable: true,
          },
        ],
      },
      missingItems: {
        type: 'table-v2',
        title: 'Top 3 Missing Items',
        api: 'bbbMissingItem',
        pagination: { pageSize: 20 },
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'itemName',
            title: 'Item Name',
            align: 'center',
          },
          {
            key: 'totalCount',
            title: 'Missing #',
            align: 'center',
          },
        ],
      },
      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'systemwide-delivery',
        sendStoreId: false,
        hideFromNonExpoUsers: true,
      },
    },
    '/:brand/delivery': {
      variables: [
        'lastTimeRange',
        {
          type: 'selectOptions',
          options: {
            deliveryKpiType: {
              defaultId: [['orderWithAccuracyIssuePercent']],
              options: [
                {
                  id: 'orderWithAccuracyIssuePercent',
                  parentId: 'root',
                  displayName: '% Orders w/ Accuracy Issues',
                },
                {
                  id: 'orderWithCancellationsIssuePercent',
                  parentId: 'root',
                  displayName: '% Orders w/ Cancellations Issues',
                },
                {
                  id: 'orderWithLatenessIssuePercent',
                  parentId: 'root',
                  displayName: '% Orders w/ Lateness Issues',
                },
                {
                  id: 'combinedStarRating',
                  parentId: 'root',
                  displayName: 'Doordash Rating',
                },
              ],
            },
          },
        },
        {
          type: 'date',
          types: ['week', 'period', 'quarter', 'year', 'trailing_7_days'],
          endDate: moment().startOf('weeks').format('YYYY-MM-DD'),
        },
      ],
      groupFilter: {
        api: 'locationFilter',
      },
      dateFilter: {
        types: ['week', 'period', 'quarter', 'year', 'trailing_7_days'],
        endDate: moment().startOf('weeks').format('YYYY-MM-DD'),
      },
      title: {
        type: 'title',
        title: 'Delivery',
        subTitle: ['Updated Weekly'],
      },
      expoAi: {
        type: 'ai-summary-box',
        api: 'bbbLocationDeliveryAiSummary',
      },
      listLocationDeliveryKpis: {
        type: 'list',
        api: 'bibibopListLocationDeliveryKpis',
        fieldWidth: '160px',
        fields: [
          {
            content: {
              key: 'totalOrderCount',
            },
            bottom: '# of Delivery Orders	',
          },
          {
            content: {
              key: 'sumSubtotal',
            },
            bottom: 'Delivery Sales',
          },
          {
            content: {
              key: 'completedDisputeAmount',
            },
            bottom: 'Completed Disputes',
          },
          {
            content: {
              key: 'deliveryAvgDasherWaitTimeDoordash',
              decimal: 1,
              format: '<%- valueStr + " min" %>',
            },
            bottom: 'Average Driver Wait Time',
          },
          {
            content: {
              key: 'deliveryOrderWithAnyIssuePercentDoordash',
              decimal: 1,
            },
            bottom: '% Orders w/ Any Issues',
          },
          {
            content: {
              key: 'deliveryAvgCustomerReviewScoreDoordash',
              decimal: 2,
            },
            bottom: 'Doordash Rating',
          },
        ],
      },
      listLocationDeliveryRanking: {
        type: 'list',
        title: 'Store Ranking',
        api: 'bibibopDeliveryRanking',
        fieldWidth: '160px',
        fields: [
          {
            content: {
              key: 'sumSubtotalRanking',
            },
            bottom: 'Delivery Sales',
          },
          {
            content: {
              key: 'orderWithAnyIssuePercentRanking',
            },
            bottom: '% Orders w/ Any Issues',
          },
          {
            content: {
              key: 'inaccurateOrderPercentRanking',
            },
            bottom: '% Orders w/ Accuracy Issues',
          },
          {
            content: {
              key: 'cancelledOrderPercentRanking',
            },
            bottom: '% Orders w/ Cancellations',
          },
          {
            content: {
              key: 'delayedOrderPercentRanking',
            },
            bottom: '% Orders w/ Late Issues',
          },
          {
            content: {
              key: 'avgCustomerReviewScoreRanking',
            },
            bottom: 'Doordash Rating',
          },
        ],
      },
      breakdownOfIssuesTitle: {
        type: 'title',
        title: 'Breakdown of Order Issues',
      },
      breakdownOfIssuesKpis: {
        type: 'list',
        api: 'listLocationDeliveryKpis',
        fieldWidth: '160px',
        fields: [
          {
            content: {
              key: 'deliveryInaccurateOrderPercentDoordash',
              decimal: 1,
            },
            bottom: 'Accuracy',
          },
          {
            content: {
              key: 'deliveryCancelledOrderPercentDoordash',
              decimal: 1,
            },
            bottom: 'Cancellations',
          },
          {
            content: {
              key: 'deliveryDelayedOrderPercentDoordash',
              decimal: 1,
            },
            bottom: 'Lateness',
          },
        ],
      },
      correctOrderPercentTrendChartTitle: {
        type: 'typography',
        apiOrContent: 'Correct Order Percent Trend',
        margin: '80px 0px 0px',
      },
      correctOrderPercentTrendChart: {
        type: 'line-chart',
        api: 'bbbTrendLocationDelivery',
        width: 1100,
        height: 350,
        label: 'date',
        datasets: [
          {
            key: 'deliveryCorrectOrderPercentDoordash',
            label: 'Store Correct Order Percent',
            decimal: 2,
          },
          {
            key: 'systemwideDeliveryCorrectOrderPercentDoordash',
            label: 'Systemwide Correct Order Percent',
            decimal: 2,
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
          },
        },
        options: {
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {
              title: {
                text: 'Correct Order Percent',
              },
            },
          },
        },
      },
      deliveryKpiTypeFilters: {
        type: 'grid',
        layout: 'space-between',
        alignItems: 'center',
        children: {
          title: {
            type: 'typography',
            apiOrContent: 'Staff at a Glance',
          },
          columns: {
            type: 'select',
            value: 'selectOptions.deliveryKpiType.value',
            onChange: 'selectOptions.deliveryKpiType.onChange',
            options: 'selectOptions.deliveryKpiType.options',
          },
        },
      },
      subTitle: {
        type: 'typography',
        apiOrContent:
          'This data shows team members who were working at the time that a delivery order was placed',
        variant: 'body2',
        margin: '0px',
      },
      staffAtAGlanceTable: {
        type: 'table-v2',
        api: 'bbbDeliveryStaff',
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'rowIndex',
            title: 'Rank',
            align: 'center',
          },
          {
            key: 'employeeName',
            title: 'Employee Name',
            width: '250px',
          },
          {
            key: 'employeeRoleName',
            title: 'Position',
            align: 'center',
          },
          {
            key: 'inaccurateOrderPercent',
            title: '% Orders w/ Accuracy Issues',
            hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithAccuracyIssuePercent")) %>',
            align: 'center',
            width: '250px',
            decimal: 1,
            sortable: true,
          },
          {
            key: 'cancelledOrderPercent',
            title: '% Orders w/ Cancellations Issues',
            hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithCancellationsIssuePercent")) %>',
            align: 'center',
            width: '275px',
            decimal: 1,
            sortable: true,
          },
          {
            key: 'delayedOrderPercent',
            title: '% Orders w/ Lateness Issues',
            hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithLatenessIssuePercent")) %>',
            align: 'center',
            width: '250px',
            decimal: 1,
            sortable: true,
          },
          {
            key: 'avgCustomerReviewScore',
            title: 'Doordash Rating',
            hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("combinedStarRating")) %>',
            align: 'center',
            width: '225px',
            decimal: 2,
            sortable: true,
          },
          {
            key: 'totalOrderCount',
            title: '# of Orders',
            align: 'center',
            width: '150px',
            sortable: true,
          },
        ],
      },
      deliveryDayTrendsFilters: {
        type: 'grid',
        layout: 'space-between',
        children: {
          deliveryDayTrendsTitle: {
            type: 'typography',
            apiOrContent: 'Day Trends',
          },
          deliveryKpiTypeSelector: {
            type: 'select',
            value: 'selectOptions.deliveryKpiType.value',
            onChange: 'selectOptions.deliveryKpiType.onChange',
            options: 'selectOptions.deliveryKpiType.options',
          },
        },
      },
      dayTrendsTable: {
        type: 'table-v2',
        api: 'listLocationDeliveryDayTrendsData',
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'dayOfWeekName',
            title: 'Day of Week',
            align: 'center',
            width: '150px',
          },
          {
            key: 'lunch',
            title: 'Lunch',
            align: 'center',
            children: [
              {
                key: 'lunchOrderWithAnyIssuePercent',
                title: '% Orders w/ Accuracy Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithAnyIssuePercent")) %>',
                align: 'center',
                width: '250px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'lunchInaccurateOrderPercent',
                title: '% Orders w/ Accuracy Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithAccuracyIssuePercent")) %>',
                align: 'center',
                width: '250px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'lunchCancelledOrderPercent',
                title: '% Orders w/ Cancellations Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithCancellationsIssuePercent")) %>',
                align: 'center',
                width: '270px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'lunchDelayedOrderPercent',
                title: '% Orders w/ Lateness Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithLatenessIssuePercent")) %>',
                align: 'center',
                width: '250px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'lunchAvgCustomerReviewScore',
                title: 'Doordash Rating',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("combinedStarRating")) %>',
                align: 'center',
                width: '250px',
                decimal: 2,
                sortable: true,
              },
              {
                key: 'lunchTotalOrderCount',
                title: '# of Orders',
                align: 'center',
                width: '120px',
                sortable: true,
              },
            ],
          },
          {
            key: 'dinner',
            title: 'Dinner',
            align: 'center',
            children: [
              {
                key: 'dinnerOrderWithAnyIssuePercent',
                title: '% Orders w/ Accuracy Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithAnyIssuePercent")) %>',
                align: 'center',
                width: '250px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'dinnerInaccurateOrderPercent',
                title: '% Orders w/ Accuracy Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithAccuracyIssuePercent")) %>',
                align: 'center',
                width: '250px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'dinnerCancelledOrderPercent',
                title: '% Orders w/ Cancellations Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithCancellationsIssuePercent")) %>',
                align: 'center',
                width: '270px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'dinnerDelayedOrderPercent',
                title: '% Orders w/ Lateness Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithLatenessIssuePercent")) %>',
                align: 'center',
                width: '250px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'dinnerAvgCustomerReviewScore',
                title: 'Doordash Rating',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("combinedStarRating")) %>',
                align: 'center',
                width: '250px',
                decimal: 2,
                sortable: true,
              },
              {
                key: 'dinnerTotalOrderCount',
                title: '# of Orders',
                align: 'center',
                width: '120px',
                sortable: true,
              },
            ],
          },
          {
            key: 'all',
            title: 'All',
            align: 'center',
            children: [
              {
                key: 'allOrderWithAnyIssuePercent',
                title: '% Orders w/ Accuracy Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithAnyIssuePercent")) %>',
                align: 'center',
                width: '250px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'allInaccurateOrderPercent',
                title: '% Orders w/ Accuracy Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithAccuracyIssuePercent")) %>',
                align: 'center',
                width: '250px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'allCancelledOrderPercent',
                title: '% Orders w/ Cancellations Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithCancellationsIssuePercent")) %>',
                align: 'center',
                width: '270px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'allDelayedOrderPercent',
                title: '% Orders w/ Lateness Issues',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("orderWithLatenessIssuePercent")) %>',
                align: 'center',
                width: '250px',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'allAvgCustomerReviewScore',
                title: 'Doordash Rating',
                hide: '<%- !selectOptions.deliveryKpiType.value.some(v => v.includes("combinedStarRating")) %>',
                align: 'center',
                width: '250px',
                decimal: 2,
                sortable: true,
              },
              {
                key: 'allTotalOrderCount',
                title: '# of Orders',
                align: 'center',
                width: '120px',
                sortable: true,
              },
            ],
          },
        ],
      },
      disputeReasonMetrics: {
        type: 'table-v2',
        title: 'Dispute Metrics',
        api: 'bbbDisputeReason',
        pagination: { pageSize: 20 },
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'reason',
            title: 'Reason',
            align: 'center',
            sortable: true,
          },
          {
            key: 'totalCount',
            title: '# of Orders',
            width: '75px',
            align: 'center',
            sortable: true,
          },
          {
            key: 'totalOrderPercent',
            title: '% of Orders',
            width: '75px',
            align: 'center',
            sortable: true,
          },
          {
            key: 'totalAmount',
            title: '$',
            width: '75px',
            align: 'center',
            decimal: 2,
            sortable: true,
          },
        ],
      },
      missingItems: {
        type: 'table-v2',
        title: 'Top 3 Missing Items',
        api: 'bbbMissingItem',
        pagination: { pageSize: 20 },
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'itemName',
            title: 'Item Name',
            align: 'center',
          },
          {
            key: 'totalCount',
            title: 'Missing #',
            align: 'center',
          },
        ],
      },
    },
  },
}

export default bibibopDeliveryConfig
